// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-scoreboard {
    margin: auto;
    font-size: 2rem;
    font-weight: 700;
    text-shadow: -1px 0 #524f4d, 0 1px #524f4d, 1px 0 #524f4d, 0 -1px #524f4d;
}

.a-team {
    color: #386994;
}

.b-team {
    color: #f55733;
}
`, "",{"version":3,"sources":["webpack://./src/style/team.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yEAAyE;AAC7E;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".team-scoreboard {\n    margin: auto;\n    font-size: 2rem;\n    font-weight: 700;\n    text-shadow: -1px 0 #524f4d, 0 1px #524f4d, 1px 0 #524f4d, 0 -1px #524f4d;\n}\n\n.a-team {\n    color: #386994;\n}\n\n.b-team {\n    color: #f55733;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
